import { render, staticRenderFns } from "./pic_border.vue?vue&type=template&id=63ff6edc&scoped=true"
import script from "./pic_border.vue?vue&type=script&lang=js"
export * from "./pic_border.vue?vue&type=script&lang=js"
import style0 from "./pic_border.vue?vue&type=style&index=0&id=63ff6edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff6edc",
  null
  
)

export default component.exports